import { renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d0ff5a40")

_pushScopeId("data-v-d0ff5a40")
const _hoisted_1 = { class: "layer-popup" }
const _hoisted_2 = { class: "layer-popup__wraap" }
const _hoisted_3 = { class: "layer-popup__content" }
const _hoisted_4 = { class: "layer-popup__actions" }
const _hoisted_5 = { class: "p-field-checkbox" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "displayNone7Days" }, "7일간 표시 안함", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("닫기")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Checkbox, {
            id: "displayNone7Days",
            modelValue: _ctx.displayNone7Days,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayNone7Days = $event)),
            binary: true
          }, null, 8, ["modelValue"]),
          _hoisted_6
        ]),
        _createVNode("div", null, [
          _createVNode(_component_Button, {
            class: "-button -royalBlue",
            onClick: _ctx.close
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
})